<template><div><h3>FormPreview_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fform-preview"/>
<p><a href="https://vux.li/demos/v2/#/component/form-preview" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/form-preview</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/form-preview" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">form-preview</span> <span class="hljs-attr">:header-label</span>=<span class="hljs-string">"$t('付款金额')"</span> <span class="hljs-attr">header-value</span>=<span class="hljs-string">"¥2400.00"</span> <span class="hljs-attr">:body-items</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">:footer-buttons</span>=<span class="hljs-string">"buttons1"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">form-preview</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">form-preview</span> <span class="hljs-attr">:header-label</span>=<span class="hljs-string">"$t('付款金额')"</span> <span class="hljs-attr">header-value</span>=<span class="hljs-string">"¥2400.00"</span> <span class="hljs-attr">:body-items</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">:footer-buttons</span>=<span class="hljs-string">"buttons2"</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"demo"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">form-preview</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">form-preview</span> <span class="hljs-attr">:header-label</span>=<span class="hljs-string">"$t('付款金额')"</span> <span class="hljs-attr">header-value</span>=<span class="hljs-string">"¥2400.00"</span> <span class="hljs-attr">:body-items</span>=<span class="hljs-string">"list"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">form-preview</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>



<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { FormPreview } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    FormPreview
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">list</span>: [{
        <span class="hljs-attr">label</span>: <span class="hljs-string">'商品'</span>,
        <span class="hljs-attr">value</span>: <span class="hljs-string">'电动打蛋机'</span>
      }, {
        <span class="hljs-attr">label</span>: <span class="hljs-string">'标题标题'</span>,
        <span class="hljs-attr">value</span>: <span class="hljs-string">'名字名字名字'</span>
      }, {
        <span class="hljs-attr">label</span>: <span class="hljs-string">'标题标题'</span>,
        <span class="hljs-attr">value</span>: <span class="hljs-string">'很长很长的名字很长很长的名字很长很长的名字很长很长的名字很长很长的名字'</span>
      }],
      <span class="hljs-attr">buttons1</span>: [{
        <span class="hljs-attr">style</span>: <span class="hljs-string">'default'</span>,
        <span class="hljs-attr">text</span>: <span class="hljs-string">'辅助操作'</span>
      }, {
        <span class="hljs-attr">style</span>: <span class="hljs-string">'primary'</span>,
        <span class="hljs-attr">text</span>: <span class="hljs-keyword">this</span>.$t(<span class="hljs-string">'跳转到首页'</span>),
        <span class="hljs-attr">link</span>: <span class="hljs-string">'/'</span>
      }],
      <span class="hljs-attr">buttons2</span>: [{
        <span class="hljs-attr">style</span>: <span class="hljs-string">'primary'</span>,
        <span class="hljs-attr">text</span>: <span class="hljs-keyword">this</span>.$t(<span class="hljs-string">'点击事件'</span>),
        <span class="hljs-attr">onButtonClick</span>: <span class="hljs-function">(<span class="hljs-params">name</span>) =&gt;</span> {
          alert(<span class="hljs-string">`clicking <span class="hljs-subst">${name}</span>`</span>)
        }
      }]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// form-preview-380.vue?ceccb69c